<template>
  <div class="delete">
    <a-modal
      v-model="visible"
      centered
      :closable="false"
      :maskClosable="false"
      :footer="null"
      :bodyStyle="bodyStyle"
      :width="436"
    >
      <!-- @cancel="doCancle" -->
      <div class="delete-title">
        <sass-icon type="hi-yiwen" style="font-size: 20px" class="title-icon"/>
        <span class="title-font">提示</span>
      </div>
      <div class="tip-content">
        <div>您的账号已在其它地方登录，请选择处理方式</div>
        <!-- <div class="content-check">
          <a-checkbox v-model="singout" @change="onChange(1)">
            退出其它登录
          </a-checkbox>
          <a-checkbox v-model="retain" @change="onChange(2)">
            保留其它登录
          </a-checkbox>
        </div> -->
      </div>
      <div class="delete-footer">
        <a-button class="footer-cancle" @click="doComfirm(2)">保留其它登录</a-button>
        <a-button class="footer-cancle" @click="doComfirm(1)">退出其它登录</a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
import CommonIcon from '@/components/common-icon'
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: null
    }
  },
  components: {
    CommonIcon
  },
  computed: {
    visible: {
      get () {
        return this.isVisible
      },
      set () {}
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.tipInfo = this.info ? this.info : this.tipInfo
      }
    }
  },
  data () {
    return {
      singout: false, // 退出登录
      retain: false, // 保留登录
      checkMode: null, // 选择是否退出
      tipInfo: { // 使用弹窗传参
        title: '确认删除？',
        detail: '确认删除？删除后数据不可恢复'
      },
      bodyStyle: {
        paddingTop: '24px!important',
        paddingBottom: '24px!important',
        paddingLeft: '24px!important',
        paddingRight: '24px!important',
        height: '174px!important'
      }
    }
  },
  methods: {
    // 点击确认
    doComfirm (msg) {
      this.checkMode = msg
      // if (!this.checkMode) {
      //   this.$message.info('请选择处理方式')
      //   return false
      // }
      // const obj = {}
      // obj.type = this.tipInfo.type
      // if (this.tipInfo.row) obj.row = this.tipInfo.row
      this.$emit('close-tip', this.checkMode)
    },
    // 点击选择
    onChange (msg) {
      this.checkMode = msg
      // this.singout = !this.retain
      if (msg === 1) {
        this.singout = true
        this.retain = false
      } else {
        this.singout = false
        this.retain = true
      }
    },
    // 点击取消
    doCancle () {
      // this.visible = false
      this.$emit('close-tip', -1)
    }
  }
}
</script>
<style lang='less' scoped>
.delete-title {
  display: flex;
  position: relative;
  height: 24px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  line-height: 24px;
  flex-direction: row;
  align-items: center;
  .title-icon {
    color: #faad14;
  }
  .title-close {
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 56px;
    // text-align: center;
    line-height: 56px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    // border: 1px solid red;
  }
  .title-font {
    margin-left: 16px;
    font-family: 'PingFangSC-Medium';
    font-size: 16px;
    color: rgba(51, 51, 51, .85);
  }
}
.tip-content {
  margin-top: 13px;
  padding-left: 36px;
  font-size: 14px;
  line-height: 20px;
  color: rgba(51, 51, 51, .85);
  .title-icon {
    margin: 0 16px 0 24px;
    vertical-align: middle;
    color: #faad14;
  }
}
.delete-footer {
  display: flex;
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 56px;
  text-align: right;
  justify-content: flex-end;
  align-items: center;
  .footer-comfirm {
    border-radius: 2px;
    height: 32px !important;
    color: #fff;
    background: #00a497;
  }
  .footer-cancles {
    margin-left: 8px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    height: 32px !important;
    // margin-top: 12px;
    // margin-right: 24px;
    background: #00a497;
  }
  .footer-cancle {
    // margin-top: 12px;
    margin-right: 24px;
    margin-left: 8px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    height: 32px !important;
    color: #fff;
    background: #00a497;
  }
}
/deep/.ant-modal-content {
  width: 436px;
  height: 197px;
}
.content-check {
  margin-top: 20px;
}
</style>
